export default __webpack_public_path__ + "static/hp-brand-deck-24-0229aef6ecd84b19ff3ef088d5774a4c.png";